/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-10 11:04:05
 * @LastEditors: caiqin.xie
 * @message: 维修价格-搜索组件
 */
import React, {useEffect, useState} from "react";
import { Select } from '@arco-design/web-react';
import styles from "../../index.module.scss";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  productList: Record<string, string>[]; // 产品列表
  categoryList: Record<string, string>[]; // 产品分类列表
  categoryChange: (categoryId: string) => void; // 产品分类change
  productChange: (productId: string) => void; // 产品change
  defaultProductId?: string; // 初始化产品id/分类改变时当前分类下首个产品id
}
const Option = Select.Option;
const Search = (props:IProps) => {
  console.log(props)
  const {ctry, words, productList, categoryList, categoryChange, productChange} = props
  const [category, setCategory] = useState( categoryList[0]?.id || ''); // 产品分类
  const [product, setProduct] = useState(props?.defaultProductId || ''); // 产品

  // 初始化产品id
  useEffect(() => {
    setProduct(props.defaultProductId)
  }, [props.defaultProductId])

  // 产品分类change
  const handleCategoryChange = (value: string) => {
    setCategory(value)
    categoryChange(value)
  }
  
  // 产品change
  const handleProductChange = (value: string) => {
    setProduct(value)
    productChange(value)
  }
  return (
    <div className={styles['search-wrap']}>
      <div className={styles["search-item"]}>
        <Select
          size='large'
          placeholder={words?.support_maintenance_price_search_category}
          value={category}
          onChange={(value: string) => handleCategoryChange(value)}>
            {categoryList.map((item, index) => (
              <Option key={item.id} value={item.id}>{item.name}</Option>
            ))}
        </Select>
        {/* Choose product categories */}
      </div>
      <div className={styles["search-item"]}>
        <Select
          size='large'
          placeholder={words?.support_maintenance_price_search_model}
          value={product}
          onChange={(value: string) => handleProductChange(value)}>
            {productList.map((item, index) => (
              <Option key={item.id} value={item.id}>{item.name}</Option>
            ))}
        </Select>
        {/* Search device model */}
      </div>
    </div>
  )
}
export default Search